import { SVG, SVGProps } from './svg'

export function IconToolArrow(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="M24.5 7.8a.5.5 0 00-.5-.3h-7a.5.5 0 000 1h5.8L7.6 23.6a.5.5 0 00.8.8L23.5 9.2V15a.5.5 0 001 0V8v-.2z" />
    </SVG>
  )
}
